<header class="detail-header">
  <!-- Top row: navigation (back) and the record actions, so the actions
       don't add height to the title row. -->
  <div class="detail-top-row">
    <a
      class="detail-back"
      *ngIf="!backCommand()"
      [routerLink]="backLink()"
      [queryParams]="backQueryParams()"
    >
      <i class="fa-solid fa-arrow-left fa-fw"></i>
      <span>{{ backLabel() | translate }}</span>
    </a>
    <!-- A page that must intercept the back link (unsaved changes) passes a
         command instead of a route. -->
    <a
      class="detail-back"
      *ngIf="backCommand() as command"
      href="#"
      (click)="$event.preventDefault(); command()"
    >
      <i class="fa-solid fa-arrow-left fa-fw"></i>
      <span>{{ backLabel() | translate }}</span>
    </a>
    <div class="detail-actions" *ngIf="hasActions()">
      <sh-action-bar
        [primaryAction]="primaryAction()"
        [secondaryActions]="secondaryActions()"
        [overflowActions]="overflowActions()"
      ></sh-action-bar>
    </div>
  </div>

  <!-- Summary row: the identity (title, status, subline) never shrinks or
       wraps; the key facts take the remaining width and hide what doesn't fit. -->
  <div class="detail-summary">
    <div class="detail-identity">
      <div class="detail-title-row">
        <h1 class="detail-title">{{ title() }}</h1>
        <sh-tag
          *ngIf="status() as status"
          [severity]="status.severity"
          [label]="status.label"
        ></sh-tag>
      </div>
      <div class="detail-subline" *ngIf="subline()">{{ subline() }}</div>
    </div>

    <div class="detail-facts" #factsRow *ngIf="visibleFacts().length > 0">
      <div
        class="detail-fact"
        *ngFor="let fact of visibleFacts(); trackBy: trackByFactLabel"
      >
        <span class="label">{{ fact.label | translate }}</span>
        <span
          class="detail-fact-value"
          [class.detail-fact-value-emphasis]="fact.emphasis"
          >{{ fact.value }}</span
        >
      </div>
    </div>

    <!-- Outside the wrapping facts row, so it is never hidden itself and the row shrinks by its width. -->
    <button
      type="button"
      class="detail-facts-more"
      *ngIf="hiddenFacts().length > 0"
      [attr.aria-label]="
        'shell.detail.moreFacts' | translate: { count: hiddenFacts().length }
      "
      [title]="
        'shell.detail.moreFacts' | translate: { count: hiddenFacts().length }
      "
      (click)="morePopover.toggle($event)"
    >
      +{{ hiddenFacts().length }}
    </button>
  </div>

  <sh-popover #morePopover styleClass="detail-facts-popover">
    <div class="detail-facts-list">
      <div
        class="detail-facts-list-item"
        *ngFor="let fact of hiddenFacts(); trackBy: trackByFactLabel"
      >
        <span class="label">{{ fact.label | translate }}</span>
        <span
          class="detail-fact-value"
          [class.detail-fact-value-emphasis]="fact.emphasis"
          >{{ fact.value }}</span
        >
      </div>
    </div>
  </sh-popover>

  <div class="detail-tabs">
    <ng-content select="[detailTabs]"></ng-content>
  </div>
</header>
